import { ReactElement } from "react";
import Layout from "../components/layout";
import BrandsList from "../components/Brands";

const BrandPage = (): ReactElement => {
  return (
    <Layout>
      <BrandsList />
    </Layout>
  );
};

export default BrandPage;
